import { useCallback } from 'react';
import { useLocale } from '@/contexts/LocaleContext';
import { getTranslation } from '@/i18n/translations';

export const useTranslation = () => {
  const { locale } = useLocale();

  const t = useCallback(
    (key: string, params?: Record<string, string | number>): string => {
      return getTranslation(key, locale.language_code, params);
    },
    [locale.language_code]
  );

  return { t, language: locale.language_code };
};
